module.exports = __webpack_public_path__ + "static/media/compserimage.69ecec18.gif";